module.exports = require("bowser");